import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export const Security = (
    props
) => (
    <SvgIcon {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.62557 23.8493C9.86047 23.9487 10.1258 23.9487 10.3607 23.8492C14.332 22.1669 16.8869 19.3549 18.2883 16.0424C19.9359 12.1338 20.0266 5.92301 19.9956 3.5639C19.9886 3.02913 19.549 2.61511 19.0146 2.59172C14.761 2.40549 11.7852 1.02129 10.5844 0.355596C10.22 0.153535 9.76661 0.153903 9.40236 0.356365C8.20416 1.02235 5.23636 2.40554 0.985359 2.59171C0.451048 2.61511 0.0114147 3.02913 0.00438647 3.56391C-0.0266175 5.92301 0.0640937 12.1338 1.71171 16.0424C3.11292 19.3546 5.66752 22.1734 9.62557 23.8493Z"
            fill="#0062B4"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 9.44901C8.56794 9.45416 7.13648 9.5305 6.40198 9.66436C5.48198 9.83203 5.48406 9.92972 5.50535 10.9282C5.5091 11.1043 5.51345 11.3083 5.51345 11.5456C5.51345 14.23 7.52189 16.4982 10 16.5C12.4781 16.4982 14.4865 14.23 14.4865 11.5456C14.4865 11.3087 14.4909 11.1049 14.4946 10.9291C14.5159 9.93059 14.518 9.83203 13.598 9.66436C12.8635 9.5305 11.4321 9.45416 10 9.44901ZM10.814 12.2513C10.6685 12.53 10.5466 12.868 10.6778 13.1537C10.8675 13.5665 10.5659 14.0369 10.1116 14.0369H9.89195C9.43767 14.0369 9.13607 13.5665 9.32572 13.1537C9.45696 12.868 9.33499 12.53 9.18954 12.2513C9.10288 12.0853 9.053 11.8905 9.053 11.6822C9.053 11.0744 9.47778 10.5817 10.0018 10.5817C10.5257 10.5817 10.9505 11.0744 10.9505 11.6822C10.9505 11.8905 10.9006 12.0853 10.814 12.2513Z"
            fill="white"
        />
        <path
            d="M13.2886 9.8746C13.2903 9.81925 13.2912 9.76363 13.2912 9.70776C13.2912 7.38388 11.8186 5.5 10.0021 5.5C8.18566 5.5 6.7131 7.38388 6.7131 9.70776C6.7131 9.76363 6.71396 9.81925 6.71564 9.8746C7.03003 9.83301 7.41869 9.79865 7.85194 9.77211C7.85172 9.75071 7.85161 9.72926 7.85161 9.70776C7.85161 7.92016 8.60485 6.72996 10.0021 6.72996C11.3994 6.72996 12.1527 7.92016 12.1527 9.70776C12.1527 9.72926 12.1525 9.75071 12.1523 9.77211C12.5856 9.79865 12.9742 9.83301 13.2886 9.8746Z"
            fill="white"
        />
    </SvgIcon>
);

Security.defaultProps = {
    viewBox: '0 0 20 24'
};

export default Security;
